module.exports = __webpack_public_path__ + "static/media/send2.f954e854.svg";